import React, { useState, useEffect } from "react";
import {
  networkingSeries,
  HeroCard,
  FollowUpLink,
  NotesWidget,
  ManageCategoriesWidget,
  SalientCheckbox
} from "./SalientComponents.js";

const ContactDetailNetworkingPage = props => {
  const series = networkingSeries.slice();
  const [contact, setContact] = useState(null);
  const [notes, setNotes] = useState([]);
  const [obj, setObj] = useState(null);

  const manageCategoriesWidget = (
    <ManageCategoriesWidget
      wordpressId={props.wordpressId}
      contacts={contact != null ? [contact] : null}
      contactsCallback={setContact}
      nonce={props.nonce}
    />
  );

  const printObj = o => {
    console.log("id: " + o.id + " networkingSeriesId:" + o.networkingSeriesId);
    o.stages.forEach(stage => {
      console.log(
        "stage info: " +
          stage.id +
          " " +
          stage.inprogress +
          " " +
          stage.complete
      );
      stage.tasks.forEach(t => {
        console.log("task info: " + t.id + " " + t.complete);
      });
    });
    console.log(
      "Type of " + typeof obj.stages.some(t => t.inprogress === true)
    );
    console.log("In progress? " + obj.stages.some(t => t.inprogress === true));
    console.log("Complete? " + obj.stages.some(t => t.complete === true));
  };

  const createObj = id => {
    const o = {
      id: id,
      networkingSeriesId: series[0].id,
      stages: series[0].stages.map(s => {
        return {
          id: s.id,
          inprogress: false,
          complete: false,
          tasks: s.tasks.map(t => {
            return { id: t.id, complete: false };
          })
        };
      })
    };
    return o;
  };

  const cloneObj = original => {
    let o = createObj(null);
    o.id = original.id;
    o.networkingSeriesId = original.networkingSeriesId;
    o.stages = original.stages.map(s => {
      return {
        id: s.id,
        inprogress: s.inprogress,
        complete: s.complete,
        tasks: s.tasks.map(t => {
          return { id: t.id, complete: t.complete };
        })
      };
    });
    return o;
  };

  const completeStage = id => {
    setObj(orig => {
      let o = cloneObj(orig);
      for (let i = 0; i <= id; i++) {
        o.stages[i].complete = true;
        o.stages[i].inprogress = false;
        o.stages[i].tasks = o.stages[i].tasks.map(t => {
          return { id: t.id, complete: true };
        });
      }
      printObj(o);
      return o;
    });
  };

  const setInprogress = id => {
    setObj(orig => {
      let o = cloneObj(orig);
      for (let i = 0; i < id; i++) {
        o.stages[i].complete = true;
        o.stages[i].inprogress = false;
        o.stages[i].tasks = o.stages[i].tasks.map(t => {
          return { ...t, complete: true };
        });
      }
      for (let i = id + 1; i < o.stages.length; i++) {
        o.stages[i].complete = false;
        o.stages[i].inprogress = false;
        o.stages[i].tasks = o.stages[i].tasks.map(t => {
          return { ...t, complete: false };
        });
      }
      printObj(o);
      o.stages[id].inprogress = true;
      o.stages[id].complete = false;
      return o;
    });
  };

  const toggleTask = ({ stageId, taskId }) => {
    setObj(orig => {
      let o = cloneObj(orig);
      o.stages[stageId].tasks[taskId].complete = !o.stages[stageId].tasks[
        taskId
      ].complete;
      return o;
    });
    checkProgress({ stageId: stageId });
  };

  const checkProgress = ({ stageId }) => {
    setObj(orig => {
      let o = cloneObj(orig);
      o.stages[stageId].complete = o.stages[stageId].tasks.every(
        t => t.complete === true
      );
      o.stages[stageId].inprogress =
        !o.stages[stageId].complete &&
        o.stages[stageId].tasks.some(t => t.complete === true);
      return o;
    });
  };

  useEffect(() => {
    const updateNetworkingProcessObj = async () => {
      await fetch("/wp-json/prism/v1/update-networking-process-object/", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          "X-WP-Nonce": props.nonce
        },
        body: JSON.stringify({ id: obj.id, obj: obj, contactId: contact.id })
      });
    };
    if (
      obj !== null &&
      contact !== null &&
      obj.stages[0].tasks.some(t => t.complete === true)
    ) {
      updateNetworkingProcessObj();
    }
  }, [obj, contact, props.nonce]);

  useEffect(() => {
    const fetchNetworkingProcessObj = async () => {
      await fetch("/wp-json/prism/v1/networking-process-object/" + contact.id, {
        headers: { "X-WP-Nonce": props.nonce }
      })
        .then(response => response.json())
        .then(result => {
          result.object == null
            ? setObj(createObj(result.id))
            : setObj(result.object);
        });
    };
    const createObj = id => {
      const o = {
        id: id,
        networkingSeriesId: series[0].id,
        stages: series[0].stages.map(s => {
          return {
            id: s.id,
            inprogress: false,
            complete: false,
            tasks: s.tasks.map(t => {
              return { id: t.id, complete: false };
            })
          };
        })
      };
      return o;
    };
    if (contact != null && obj === null) {
      setObj(createObj(null));
      fetchNetworkingProcessObj();
    }
  }, [contact, props.nonce, obj, series]);

  useEffect(() => {
    const fetchContactDetail = async id => {
      await fetch("/wp-json/prism/v1/contact-detail/" + id, {
        headers: { "X-WP-Nonce": props.nonce }
      })
        .then(response => response.json())
        .then(result => setContact(result));
    };
    if (
      props.contactId != null &&
      props.wordpressId != null &&
      props.nonce != null
    ) {
      fetchContactDetail(props.contactId);
    }
  }, [props.contactId, props.wordpressId, props.nonce]);

  const TaskList = ({ stage }) => {
    return (
      <div>
        <ul className="taskList">
          {stage != null && stage.tasks != null && stage.tasks.length > 0
            ? stage.tasks.map(t => {
                return (
                  <li key={"stage" + stage.id + "task" + t.id}>
                    <SalientCheckbox
                      checked={
                        obj != null
                          ? obj.stages[stage.id].tasks[t.id].complete
                          : false
                      }
                      onChange={() =>
                        toggleTask({
                          stageId: stage.id,
                          taskId: t.id
                        })
                      }
                    />
                    {t.task}
                  </li>
                );
              })
            : null}
        </ul>
      </div>
    );
  };

  const TipList = props => {
    return (
      <div
        className="nectar-fancy-ul"
        data-list-icon="linecon-icon-bulb"
        data-animation="false"
        data-animation-delay="0"
        data-color="extra-color-2"
        data-spacing="10px"
        data-alignment="left"
      >
        <ul>
          {props.tips != null && props.tips.length > 0
            ? props.tips.map(t => <li>{t.tip}</li>)
            : null}
        </ul>
      </div>
    );
  };

  const StatusRow = ({ stage, tasks }) => {
    return (
      <div
        data-midnight=""
        data-column-margin="default"
        data-bg-mobile-hidden=""
        className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex  vc_row-o-content-middle standard_section    "
        style={{ paddingTop: "0px", paddingBottom: "0px" }}
      >
        <div className="row-bg-wrap">
          <div className="row-bg   " />
        </div>
        <div className="col span_12  left">
          <div
            className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column centered-text no-extra-padding"
            data-t-w-inherits="default"
            data-shadow="none"
            data-border-radius="none"
            data-border-animation=""
            data-border-animation-delay=""
            data-border-width="none"
            data-border-style="solid"
            data-border-color=""
            data-bg-cover=""
            data-padding-pos="all"
            data-has-bg-color="false"
            data-bg-color=""
            data-bg-opacity="1"
            data-hover-bg=""
            data-hover-bg-opacity="1"
            data-animation=""
            data-delay="0"
          >
            <div className="vc_column-inner">
              <div className="column-bg-overlay-wrap" data-bg-animation="none">
                <div className="column-bg-overlay" />
              </div>
              <div className="wpb_wrapper">
                <div className="wpb_text_column wpb_content_element ">
                  <div className="wpb_wrapper">
                    <h5>
                      <SalientCheckbox
                        checked={
                          obj != null ? obj.stages[stage.id].inprogress : false
                        }
                        onChange={() => setInprogress(stage.id)}
                      />
                      In Progress
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            style={{ marginBottom: "2%!important" }}
            className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column centered-text no-extra-padding"
            data-t-w-inherits="default"
            data-shadow="none"
            data-border-radius="none"
            data-border-animation=""
            data-border-animation-delay=""
            data-border-width="none"
            data-border-style="solid"
            data-border-color=""
            data-bg-cover=""
            data-padding-pos="all"
            data-has-bg-color="false"
            data-bg-color=""
            data-bg-opacity="1"
            data-hover-bg=""
            data-hover-bg-opacity="1"
            data-animation=""
            data-delay="0"
          >
            <div className="vc_column-inner">
              <div className="column-bg-overlay-wrap" data-bg-animation="none">
                <div className="column-bg-overlay" />
              </div>
              <div className="wpb_wrapper">
                <div className="wpb_text_column wpb_content_element ">
                  <div className="wpb_wrapper">
                    <h5>
                      <SalientCheckbox
                        checked={
                          obj != null ? obj.stages[stage.id].complete : false
                        }
                        onChange={() => completeStage(stage.id)}
                      />
                      Complete
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      id="fws_5e82aee140e99"
      data-column-margin="default"
      data-midnight="dark"
      data-top-percent="5%"
      data-bottom-percent="7%"
      data-bg-mobile-hidden=""
      className="wpb_row vc_row-fluid vc_row top-level full-width-section standard_section "
      style={{
        paddingTop: "calc(100vw * 0.05)",
        paddingBottom: "calc(100vw * 0.07)"
      }}
    >
      <div
        className="row-bg-wrap"
        data-bg-animation="none"
        data-bg-overlay="false"
      >
        <div className="inner-wrap">
          <div className="row-bg" />
        </div>
        <div className="row-bg-overlay" />
      </div>
      <div className="col span_12 dark left">
        <HeroCard
          contact={contact}
          pageType="Networking"
          manageCategoriesWidget={manageCategoriesWidget}
        />
        <div
          className="vc_col-sm-8 wpb_column column_container vc_column_container col no-extra-padding"
          data-t-w-inherits="default"
          data-border-radius="none"
          data-shadow="none"
          data-border-animation=""
          data-border-animation-delay=""
          data-border-width="none"
          data-border-style="solid"
          data-border-color=""
          data-bg-cover=""
          data-padding-pos="all"
          data-has-bg-color="false"
          data-bg-color=""
          data-bg-opacity="1"
          data-hover-bg=""
          data-hover-bg-opacity="1"
          data-animation=""
          data-delay="0"
        >
          <div className="vc_column-inner">
            <div className="column-bg-overlay-wrap" data-bg-animation="none">
              <div className="column-bg-overlay" />
            </div>
            <div className="wpb_wrapper">
              <div className="wpb_text_column wpb_content_element ">
                <div className="wpb_wrapper">
                  <h2 style={{ textAlign: "center", color: "#05bff7" }}>
                    PRISM Networking Process
                  </h2>
                </div>
              </div>

              <div className="wpb_content_element" data-interval="0">
                <div
                  className="wpb_wrapper tabbed clearfix"
                  data-style="minimal_flexible"
                  data-spacing=""
                  data-icon-size="24"
                  data-full-width-line=""
                  data-color-scheme="extra-color-gradient-2"
                  data-alignment="left"
                >
                  <ul className="wpb_tabs_nav ui-tabs-nav clearfix">
                    <li>
                      <a href="#tab-1584925896019-1">
                        <span>BUILD</span>
                      </a>
                    </li>
                    <li>
                      <a href="#tab-1584925896284-3">
                        <span>DISCOVER</span>
                      </a>
                    </li>
                    <li>
                      <a href="#tab-1584925896519-6">
                        <span>CONNECT</span>
                      </a>
                    </li>
                    <li>
                      <a href="#tab-1584925896911-9">
                        <span>ASSESS</span>
                      </a>
                    </li>
                    <li>
                      <a href="#tab-1584925897149-2">
                        <span>ENGAGE</span>
                      </a>
                    </li>
                    <li>
                      <a href="#tab-1584925897370-8">
                        <span>MAINTAIN</span>
                      </a>
                    </li>
                  </ul>

                  <div
                    id="tab-build"
                    data-tab-icon="iconsmind-Wrench"
                    className="wpb_tab ui-tabs-panel wpb_ui-tabs-hide clearfix"
                  >
                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <p>
                          BUILD what you know about this person and copy links
                          to their social media pages into PRISM.
                          <br />
                          <FollowUpLink
                            name={
                              contact != null
                                ? contact.name.replace(/\s/g, "")
                                : null
                            }
                            id={contact != null ? contact.id : null}
                          />
                        </p>
                      </div>
                    </div>

                    <StatusRow stage={series[0].stages[0]} />
                    <div
                      id="fws_5e82aee146f57"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column padding-1-percent"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <h3>Tasks</h3>
                                </div>
                              </div>
                              <TaskList stage={series[0].stages[0]} />
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column padding-1-percent"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <h3>Tips</h3>
                                </div>
                              </div>
                              <TipList tips={series[0].stages[0].tips} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      id="fws_5e82aee147da3"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-content-top standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "3%" }}
                    >
                      <div className="row-bg-wrap">
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-12 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <NotesWidget
                                contactId={props.contactId}
                                wordpressId={props.wordpressId}
                                stage={series[0].stages[0]}
                                showStageOnly={true}
                                notes={notes}
                                callback={setNotes}
                                showAddNotes={true}
                                showSearchNotes={true}
                                nonce={props.nonce}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="tab-discover"
                    data-tab-icon="iconsmind-Search-People"
                    className="wpb_tab ui-tabs-panel wpb_ui-tabs-hide clearfix"
                  >
                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <p>
                          DISCOVER what else you can learn about this person by
                          doing research and adding information into PRISM.
                          <br />
                          <FollowUpLink
                            name={
                              contact != null
                                ? contact.name.replace(/\s/g, "")
                                : null
                            }
                            id={contact != null ? contact.id : null}
                          />
                        </p>
                      </div>
                    </div>
                    <StatusRow stage={series[0].stages[1]} />
                    <div
                      id="fws_5e82aee149fef"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column padding-1-percent"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <h3>Tasks</h3>
                                </div>
                              </div>

                              <TaskList stage={series[0].stages[1]} />
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column padding-1-percent"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <h3>Tips</h3>
                                </div>
                              </div>

                              <TipList tips={series[0].stages[1].tips} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      id="fws_5e82aee14c5f4"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-content-top standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "3%" }}
                    >
                      <div className="row-bg-wrap">
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-12 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <NotesWidget
                                contactId={props.contactId}
                                wordpressId={props.wordpressId}
                                stage={series[0].stages[1]}
                                notes={notes}
                                showStageOnly={true}
                                callback={setNotes}
                                showAddNotes={true}
                                showSearchNotes={true}
                                nonce={props.nonce}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="tab-connect"
                    data-tab-icon="iconsmind-Plastic-CupPhone"
                    className="wpb_tab ui-tabs-panel wpb_ui-tabs-hide clearfix"
                  >
                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <p>
                          CONNECT either face to face or via phone, to further
                          your relationship with this person.
                          <br />
                          <FollowUpLink
                            name={
                              contact != null
                                ? contact.name.replace(/\s/g, "")
                                : null
                            }
                            id={contact != null ? contact.id : null}
                          />
                        </p>
                      </div>
                    </div>
                    <StatusRow stage={series[0].stages[2]} />
                    <div
                      id="fws_5e82aee14e49e"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column padding-1-percent"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <h3>Tasks</h3>
                                </div>
                              </div>
                              <TaskList stage={series[0].stages[2]} />
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column padding-1-percent"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <h3>Tips</h3>
                                </div>
                              </div>
                              <TipList tips={series[0].stages[2].tips} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      id="fws_5e82aee14f1c1"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-content-top standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "3%" }}
                    >
                      <div className="row-bg-wrap">
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-12 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <NotesWidget
                                contactId={props.contactId}
                                wordpressId={props.wordpressId}
                                stage={series[0].stages[2]}
                                showStageOnly={true}
                                notes={notes}
                                callback={setNotes}
                                showAddNotes={true}
                                showSearchNotes={true}
                                nonce={props.nonce}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="tab-assess"
                    data-tab-icon="iconsmind-Puzzle"
                    className="wpb_tab ui-tabs-panel wpb_ui-tabs-hide clearfix"
                  >
                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <p>
                          ASSESS how you might be able to continue to build a
                          genuine relationship with this person.
                          <br />
                          <FollowUpLink
                            name={
                              contact != null
                                ? contact.name.replace(/\s/g, "")
                                : null
                            }
                            id={contact != null ? contact.id : null}
                          />
                        </p>
                      </div>
                    </div>
                    <StatusRow stage={series[0].stages[3]} />
                    <div
                      id="fws_5e82aee150f25"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column padding-1-percent"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <h3>Tasks</h3>
                                </div>
                              </div>

                              <TaskList stage={series[0].stages[3]} />
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column padding-1-percent"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <h3>Tips</h3>
                                </div>
                              </div>

                              <TipList tips={series[0].stages[3].tips} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      id="fws_5e82aee151c26"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-content-top standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "3%" }}
                    >
                      <div className="row-bg-wrap">
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-12 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <NotesWidget
                                contactId={props.contactId}
                                wordpressId={props.wordpressId}
                                stage={series[0].stages[3]}
                                showStageOnly={true}
                                notes={notes}
                                callback={setNotes}
                                showAddNotes={true}
                                showSearchNotes={true}
                                nonce={props.nonce}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="tab-engage"
                    data-tab-icon="iconsmind-Checked-User"
                    className="wpb_tab ui-tabs-panel wpb_ui-tabs-hide clearfix"
                  >
                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <p>
                          ENGAGE again and further relationship by setting up
                          another meeting with this person.
                          <br />
                          <FollowUpLink
                            name={
                              contact != null
                                ? contact.name.replace(/\s/g, "")
                                : null
                            }
                            id={contact != null ? contact.id : null}
                          />
                        </p>
                      </div>
                    </div>
                    <StatusRow stage={series[0].stages[4]} />
                    <div
                      id="fws_5e82aee153990"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column padding-1-percent"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <h3>Tasks</h3>
                                </div>
                              </div>

                              <TaskList stage={series[0].stages[4]} />
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column padding-1-percent"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <h3>Tips</h3>
                                </div>
                              </div>

                              <TipList tips={series[0].stages[4].tips} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      id="fws_5e82aee15501e"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-content-top standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "3%" }}
                    >
                      <div className="row-bg-wrap">
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-12 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <NotesWidget
                                contactId={props.contactId}
                                wordpressId={props.wordpressId}
                                stage={series[0].stages[4]}
                                showStageOnly={true}
                                notes={notes}
                                callback={setNotes}
                                showAddNotes={true}
                                showSearchNotes={true}
                                nonce={props.nonce}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="tab-maintain"
                    data-tab-icon="iconsmind-Heart2"
                    className="wpb_tab ui-tabs-panel wpb_ui-tabs-hide clearfix"
                  >
                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <p>
                          MAINTAIN this relationship because you feel it is
                          growing into a wonderful genuine connection.
                          <br />
                          <FollowUpLink
                            name={
                              contact != null
                                ? contact.name.replace(/\s/g, "")
                                : null
                            }
                            id={contact != null ? contact.id : null}
                          />
                        </p>
                      </div>
                    </div>
                    <StatusRow stage={series[0].stages[5]} />
                    <div
                      id="fws_5e82aee15a3dc"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "0px" }}
                    >
                      <div className="row-bg-wrap">
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column padding-1-percent"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <h3>Tasks</h3>
                                </div>
                              </div>

                              <TaskList stage={series[0].stages[5]} />
                            </div>
                          </div>
                        </div>

                        <div
                          className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column padding-1-percent"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <h3>Tips</h3>
                                </div>
                              </div>

                              <TipList tips={series[0].stages[5].tips} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      id="fws_5e82aee15c7f6"
                      data-midnight=""
                      data-column-margin="default"
                      data-bg-mobile-hidden=""
                      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-content-top standard_section    "
                      style={{ paddingTop: "0px", paddingBottom: "3%" }}
                    >
                      <div className="row-bg-wrap">
                        <div className="row-bg   " />
                      </div>
                      <div className="col span_12  left">
                        <div
                          className="vc_col-sm-12 wpb_column column_container vc_column_container col child_column no-extra-padding"
                          data-t-w-inherits="default"
                          data-shadow="none"
                          data-border-radius="none"
                          data-border-animation=""
                          data-border-animation-delay=""
                          data-border-width="none"
                          data-border-style="solid"
                          data-border-color=""
                          data-bg-cover=""
                          data-padding-pos="all"
                          data-has-bg-color="false"
                          data-bg-color=""
                          data-bg-opacity="1"
                          data-hover-bg=""
                          data-hover-bg-opacity="1"
                          data-animation=""
                          data-delay="0"
                        >
                          <div className="vc_column-inner">
                            <div
                              className="column-bg-overlay-wrap"
                              data-bg-animation="none"
                            >
                              <div className="column-bg-overlay" />
                            </div>
                            <div className="wpb_wrapper">
                              <NotesWidget
                                contactId={props.contactId}
                                wordpressId={props.wordpressId}
                                stage={series[0].stages[5]}
                                showStageOnly={true}
                                notes={notes}
                                callback={setNotes}
                                showAddNotes={true}
                                showSearchNotes={true}
                                nonce={props.nonce}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactDetailNetworkingPage;
